module.exports = __webpack_public_path__ + "img/circle-img.7807c1ff.svg";